import type { FeatureModule } from '@/components/routing';

import { chargersFeature } from './chargers/routes';
import { dashboardFeature } from './dashboard/routes';
import { settingsFeature } from './settings/routes';

/** Every feature of the app. The router and the navigation are composed from this list. */
export const featureModules: readonly FeatureModule[] = [dashboardFeature, chargersFeature, settingsFeature];
